import { render, staticRenderFns } from "./MyExamsComponent.vue?vue&type=template&id=646e4983"
import script from "./MyExamsComponent.vue?vue&type=script&lang=js"
export * from "./MyExamsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports